import { mutationOptions } from '@tanstack/react-query';
import { BankData } from 'merchant-api/types';
import { checkout } from '..';
import { AxiosError } from 'axios';

const bankDetails = (routingNumber: string) =>
  checkout.post<BankData>('/v1/bank-info/get-bank-details', {
    bankRoutingNumber: routingNumber,
    countryCode: 'USA',
  }).then((res) => res.data);

export const bankDetailsOpts = () =>
  mutationOptions<BankData, AxiosError, string>({
    mutationKey: ['bankDetails'],
    mutationFn: bankDetails,
  });

